// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9707db42","667":"3e322d26","977":"6008774d"}[chunkId] + ".chunk.js";
};